import { httpCreate } from './http';

const http = httpCreate('/srv/hee-order');

export const heeOrder = {
	confirm(orderNo) {
		return http.get(`/confirm/${orderNo}`);
	},
	recharge(data) {
		return http.post(`recharge`, data);
	},
};
